import getUrlParams from '@gcloud-npm/utils.common.get-url-params';
import { HOME_URL } from '@/constants/pages/baf';
import { PHONE_900 as PHONE_900_FA } from '@/constants/pages/additionalFiber';
import { getLoginUrlWithRedirect } from '@/utils/common';
import { CONFIG_URL, FA_URL } from '@/constants/constant';
import sendToRelogin from '@gcloud-npm/utils.page.send-to-relogin';

export const PHONE_900 = '900 110 619';
export const getUrlParamsString = () => {
  let searchParams = '';
  try {
    searchParams = window.location.search;
  } catch (err) {
    // Nothing to do
  }
  return searchParams;
};
export const getUrlParamsAndChangeZone = () => {
  const params = {
    ...getUrlParams({
      groupByObject: false,
      allowedParams: false,
      excludeHash: true,
      currentUrl: window.location.href,
    }),
  };
  let newParams = '';
  if (params?.zipCode) {
    params.zipCode = params.zipCode === 'libre' ? 'regulada' : 'libre';
  }

  if (params) {
    newParams = Object.keys(params)
      .map((key) => `${key}=${params[key].replace(' ', '+')}`)
      .join('&');
  }
  return `?${newParams}`;
};
export const phoneCallHref = (phone = PHONE_900) => {
  return `tel:${phone.replace(/\s/g, '')}`;
};
export const phoneCallText = (phone = PHONE_900) => {
  return `Llamar gratis al ${phone}`;
};
export const buttonLinkCallHref = (href) => {
  return href;
};
export const buttonLinkCallText = (text) => {
  return text;
};
export const DEFAULT_ERROR_PAGE_TEXT = {
  ERROR_ID: '900-PAGE',
  TITLE: ' No es posible generar tu pedido en estos momentos',
  DESCRIPTION:
    'Por favor, inténtalo pasados unos minutos o llama gratis para que un asesor comercial te ayude.',
  LINK_TEXT: 'Volver al listado',
};
export const CHECKOUT_ERROR_PAGE_TEXT = {
  TITLE: 'Lo sentimos, no hemos podido procesar tu pedido',
  DESCRIPTION:
    'Por favor, llama gratis para que un asesor comercial resuelva el problema.',
  BUTTON_TEXT: `Llamar gratis al ${PHONE_900}`,
};

export const INCOMPATIBLE_ADDITIONAL_FIBER_ERROR_PAGE_TEXT = {
  TITLE: 'Tras revisar tus datos, no podemos ofrecerte este producto',
  DESCRIPTION: `Lo sentimos, para contratar Fibra adicional debes tener contratado un pack miMovistar.</br></br>Llama gratis y un asesor comercial te ayudará a gestionar tu pedido.`,
};

export const ALREADY_PURCHASE_ADDITIONAL_FIBER_ERROR_PAGE_TEXT = {
  TITLE: 'Actualmente ya tienes contratado el producto fibra adicional',
  DESCRIPTION: `Para realizar cambios de configuración necesitamos que te pongas en contacto con nosotros llamando gratis al ${PHONE_900_FA} y un asesor comercial gestionará tu solicitud.`,
};
export const ALREADY_PURCHASE_BAF_ERROR_PAGE_TEXT = {
  TITLE: 'Actualmente ya tienes contratado este producto.',
  BUTTON_TEXT: 'Volver al listado',
  BUTTON_HREF: HOME_URL,
};
export const WRONG_ZONE_MIMOVISTAR_NO_CLIENTE = (params) => ({
  TITLE: 'Información cambio código postal',
  DESCRIPTION: `Tu dirección no pertenece al código postal de las ofertas mostradas en el configurador de miMovistar. Hemos aplicado el mejor precio posible para el producto elegido en tu código postal.`,
  BUTTON_TEXT: 'Ir al configurador',
  BUTTON_HREF: `https://www.movistar.es/fibra-y-movil/${params}`,
});

export const EMPTY_CONTACT_MEDIA_ERROR_PAGE_TEXT = {
  TITLE: 'Tus datos de contacto están incompletos.',
  DESCRIPTION: `Debes ir a tu área privada a completarlos para seguir con el pedido, sentimos las molestias.`,
  BUTTON_TEXT: 'Ir a mi Perfil',
  BUTTON_HREF: 'https://www.movistar.es/area-cliente/mi-perfil/',
};
export const INCOMPATIBLE_PROMOTION_ERROR_PAGE_TEXT = {
  TITLE: 'Lo sentimos, no podemos ofrecerte esta oferta',
  DESCRIPTION: `Tras revisar tus datos no eres compatible con la oferta seleccionada. Consulta las tarifas que tenemos disponibles para ti.`,
  BUTTON_TEXT: 'Ver ofertas disponibles',
  BUTTON_HREF: 'https://www.movistar.es/tarifas-moviles',
};
export const INCOMPATIBLE_LMA = {
  TITLE: 'Lo sentimos, no podemos ofrecerte esta tarifa',
  DESCRIPTION: `Actualmente no puedes contratar líneas adicionales. Consulta las tarifas que tenemos disponibles para ti.`,
  BUTTON_TEXT: 'Ver tarifas móviles',
  BUTTON_HREF: 'https://www.movistar.es/tarifas-moviles/',
};
export const INCOMPATIBLE_LMC_BUNDLE = {
  TITLE: 'Podemos ofrecerte tarifas a mejor precio',
  DESCRIPTION: `Por ser cliente puedes beneficiarte de un mejor precio en las tarifas de móviles, Consulta nuestro listado de líneas adicionales exclusivas de clientes.`,
  BUTTON_TEXT: 'Ver líneas adicionales',
  BUTTON_HREF: 'https://www.movistar.es/tarifas-moviles/lineas-adicionales/',
};
export const ALREADY_PURCHASE_TV = {
  TITLE: 'Actualmente ya tienes contratado este producto.',
  BUTTON_TEXT: 'Ver otras ofertas',
  BUTTON_HREF: getLoginUrlWithRedirect(CONFIG_URL),
};
export const ALREADY_PURCHASE_PROMO_TV = {
  TITLE: 'Estamos gestionando tu pedido',
  DESCRIPTION: `Tu pedido está en curso.<br/><br/>Gracias por confiar en Movistar.<br/>`,
  BUTTON_TEXT: 'Volver a movistar.es',
  BUTTON_HREF: 'https://www.movistar.es/',
};
export const ALREADY_PURCHASE_PROMO_FA = {
  TITLE: 'Estamos gestionando tu pedido',
  DESCRIPTION: `Tu pedido está en curso.<br/><br/>Gracias por confiar en Movistar.<br/>`,
  BUTTON_TEXT: 'Ver estado de mi pedido',
  BUTTON_HREF:
    'https://www.movistar.es/area-cliente/mi-perfil/seguimiento-de-pedidos/',
};
export const PROMO_EXPIRED_TV = {
  TITLE: 'Esta oferta ya no está disponible',
  DESCRIPTION:
    'Identifícate y consulta otros productos que pueden interesarte.',
  BUTTON_TEXT: 'Ver otras ofertas',
  BUTTON_HREF: getLoginUrlWithRedirect(CONFIG_URL),
};
export const PROMO_EXPIRED_FA = {
  TITLE: 'Esta oferta ya no está disponible',
  DESCRIPTION:
    'Identifícate y consulta otros productos que pueden interesarte.',
  BUTTON_TEXT: 'Ver otras ofertas',
  BUTTON_HREF: getLoginUrlWithRedirect(FA_URL),
};
export const DEFAULT_TV = {
  TITLE: 'Ha ocurrido un error',
  DESCRIPTION:
    'No es posible continuar debido a problemas técnicos. Por favor, inténtalo más tarde.',
  BUTTON_TEXT: 'Volver a movistar.es',
  BUTTON_HREF: 'https://www.movistar.es/',
};
export const ALREADY_CLIENT_ERROR_PAGE_TEXT = {
  TITLE: 'Ya eres cliente de Movistar',
  DESCRIPTION:
    'Por seguridad es necesario que inicies sesión para seguir con tu compra',
  BUTTON_TEXT: 'Iniciar sesión',
  BUTTON_ONCLICK: () => sendToRelogin(),
};
